import { ChatMessage } from '@/store/chat'
import { mockedData } from '@/store/mock/mock'
import { IApi } from '@/store/spi/api'
import {
  handleError,
  hasError,
  tryCatch,
  unknownError,
} from '@repo/shared/api/helpers'
import { ChatMessageDTO } from '@repo/shared/dtos/message'
import { PublicRoutes } from '@repo/shared/routes-public'
import { AxiosInstance } from 'axios'

type T = {
  app: IApi['chatSessions']
}

export const apiChatSessions: (api?: AxiosInstance) => T = (api): T => ({
  //
  // APP
  //
  app: {
    createOne: api
      ? async ({ beneficiaryId }) => {
          const res = await tryCatch(
            async () =>
              await api.post<PublicRoutes.chatSessions.createOne.Response>(
                PublicRoutes.chatSessions.createOne.call({ beneficiaryId }),
                {
                  beneficiaryId,
                } satisfies PublicRoutes.chatSessions.createOne.Request,
              ),
          )
          if (hasError(res)) return handleError(res)
          const chatSession = res.chatSession
          return {
            closedAt: chatSession.closedAt,
            id: chatSession.id,
            startedAt: chatSession.startedAt,
          }
        }
      : (p) => {
          if (p.beneficiaryId === 'benef1') {
            return Promise.resolve({
              id: 'cs3',
              startedAt: new Date().getTime(),
            })
          }
          return Promise.resolve(unknownError)
        },

    getInitialValuesFromOne: api
      ? async ({ chatSessionId }) => {
          const res = await tryCatch(
            async () =>
              await api.get<PublicRoutes.chatSessions.getMessagesFromOne.Response>(
                PublicRoutes.chatSessions.getMessagesFromOne.call({
                  chatSessionId,
                }),
              ),
          )
          if (hasError(res)) return handleError(res)
          return {
            chatMessages: res.chatMessages.map(toChatMessage),
          }
        }
      : () => {
          return Promise.resolve({
            chatMessages: mockedData.chatMessages,
          })
        },
  },
})

export function toChatMessage(m: ChatMessageDTO): ChatMessage {
  return {
    content: m.content,
    id: m.id,
    sender: m.sender,
    sentAt: m.sentAt,
    traceUrl: m.traceUrl,
  }
}
